// Which files a browser can show as themselves.
//
// The list is deliberately narrow and by exact MIME type rather than a `image/*`
// prefix: TIFF is an image the KB accepts and Safari renders, but Chrome and
// Firefox show a broken frame, and a broken frame reads as a bug in the app
// rather than a limit of the browser. Anything not listed is offered as a
// download instead.
const INLINE_MIME_TYPES: ReadonlySet<string> = new Set([
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/avif',
  'image/svg+xml',
])

/**
 * Undefined answers false, which is what makes a citation open on the extract:
 * a `kbdoc:` link carries an id and nothing else, so the caller has no MIME type
 * to offer and the passage is the view that always works.
 */
export const canRenderInline = (mimeType?: string): boolean =>
  Boolean(mimeType && INLINE_MIME_TYPES.has(mimeType))
